import { ScreenEvent } from '@atlassiansox/analytics-web-client';
import React from 'react';
import { analytics } from '../index';

interface ScreenEventAnalyticsProps {
  event: ScreenEvent;
  isFetching?: boolean;
}

/**
 * Component to add in pages to only send ScreenEvent when data has loaded
 *
 * Lifted from: https://bitbucket.org/atlassian/pf-site-admin-ui/src/master/src/common/analytics/screen-event-sender.tsx
 */
const ScreenEventAnalytics = (props: ScreenEventAnalyticsProps) => {
  const { event, isFetching = false } = props;
  const [hasSentEvent, setSentEvent] = React.useState(false);

  const sendAnalyticsIfLoaded = React.useCallback(() => {
    if (hasSentEvent || isFetching) {
      return;
    }

    analytics.setGlobalPageProperties({
      source: event.name,
      pageAttributes: event.attributes,
    });

    analytics.sendScreenEvent(event);
    setSentEvent(true);
  }, [event, hasSentEvent, isFetching]);

  React.useEffect(() => {
    sendAnalyticsIfLoaded();
  }, [isFetching, sendAnalyticsIfLoaded]);

  return <></>;
};

export default ScreenEventAnalytics;
